import svValuation from '../locales/sv/valuation.json';
import enValuation from '../locales/en/valuation.json';
import { getLanguage, type Language } from '@/utils/languageUtils';

const getValuationLocale = (lang?: Language) => {
  const l = lang || getLanguage();
  return l === 'en' ? enValuation : svValuation;
};

export const valuationLabels = (lang?: Language) => getValuationLocale(lang);
